export const getWindowProp = v => {
	const win = typeof window !== 'undefined' ? window : {};
	return win[v] || false;
};

export const getDocumentProp = v => {
	const doc = typeof document !== 'undefined' ? document : {};
	return doc[v] || false;
};
